"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function rdn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M7.12482 4.50449H13.2081C13.2816 4.48199 13.3191 4.54949 13.3671 4.58699C13.9405 5.12858 14.4548 5.72944 14.9016 6.37949C15.5363 7.28856 16.0346 8.28563 16.3806 9.33899C16.7421 10.452 16.9131 11.6295 16.8681 12.7995H13.7668C13.7821 12.644 13.7876 12.4877 13.7833 12.3315C13.7511 11.2282 13.4106 10.146 12.8743 9.18749C12.3006 8.16074 11.4996 7.27499 10.5891 6.53924C9.59757 5.73749 8.48157 5.10449 7.31907 4.59299C7.25457 4.56299 7.18707 4.53899 7.12482 4.50449ZM9.37632 9.99974C10.4168 11.882 11.4555 13.7653 12.4926 15.6495C12.7423 16.104 12.9951 16.557 13.2426 17.0122C11.9518 17.8387 10.6648 18.6727 9.37482 19.5V9.99974H9.37632Z", fill: color }));
}
exports["default"] = rdn;
//# sourceMappingURL=rdn.js.map